import React, { memo, useState, useCallback } from "react";
import { Box } from "@mui/material";
import {
  Close as NoneIcon,
  TextFields as TextIcon,
  Image as ImageIcon,
  Videocam as VideoIcon,
  Description as DocumentIcon,
  LocationOn as LocationIcon,
} from "@mui/icons-material";
import IconRadioSelect from "./IconRadioSelect";
import TextFieldWithVariableButton from "./TextFieldVariableButton";

const optionsList = [
  { value: "NONE", label: "None", icon: <NoneIcon /> },
  { value: "TEXT", label: "Text", icon: <TextIcon /> },
  { value: "IMAGE", label: "Image", icon: <ImageIcon /> },
  { value: "VIDEO", label: "Video", icon: <VideoIcon /> },
  { value: "DOCUMENT", label: "Document", icon: <DocumentIcon /> },
  { value: "LOCATION", label: "Location", icon: <LocationIcon /> },
];

function HeaderOptions({
  value: valueProp,
  defaultValue = { type: "NONE" },
  onChange,
  onMediaUrl,
  variableType = "Number",
}) {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const isControlled = valueProp !== undefined;
  const value = (isControlled ? valueProp : internalValue) || { type: "NONE" };
  const emit = useCallback(
    (next) => {
      if (!isControlled) setInternalValue(next);
      onChange?.(next);
    },
    [isControlled, onChange]
  );

  const handleType = (event) => {
    emit({ type: event.target.value, text: "", mediaId: "" });
  };
  const { type = "NONE", text = "" } = value;

  return (
    <Box>
      <IconRadioSelect
        options={optionsList}
        label="Content Type"
        size="small"
        value={type}
        onChange={handleType}
        sx={{ mb: 2 }}
      />
      {type === "TEXT" && (
        <Box sx={{ mt: 1 }}>
          <TextFieldWithVariableButton
            value={text}
            onChange={(newText, param) =>
              emit({ ...value, text: newText, param })
            }
            variableType={variableType}
            varLimitCount={1}
            charLimit={60}
          />
        </Box>
      )}
    </Box>
  );
}

export default memo(HeaderOptions);
